export default "__VITE_ASSET__8onNuklC__"